import React, { useState } from 'react';
import { connect } from 'react-redux';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { closePersonAddressEdit } from 'reducers/DialogsReducer';
import Dialog from 'components/Dialog';
import AddressEdit from 'Dialogs/Address/AddressEdit';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';

function EditPersonAddressDialog(props) {
  const { ptsAddressID } = props;
  const [isAddressFormDirty, setIsAddressFormDirty] = useState(false);

  const close = () => {
    props.notifyDataUpdate({ type: 'Address' });
    props.closePersonAddressEdit();
  };

  const renderActions = () => {
    return (
      <>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  return (
    <Dialog toolbar onClose={close} title="Address Edit" actions={renderActions()}>
      <AddressEdit ptsAddressID={ptsAddressID} setIsAddressFormDirty={setIsAddressFormDirty} />
    </Dialog>
  );
}

export default connect(null, { closePersonAddressEdit, notifyDataUpdate })(EditPersonAddressDialog);
